<script>
    import { apiURL } from '../../store.js'
    export let courses
    export let color
</script>

<div class="courses" style="--pageColor: {color}">
    {#each courses as course, i}
        {#if course.image.url != 'none'}
            <img
                src="{apiURL}{course.image.url}"
                alt="course {i} img"
            />
        {/if}
        <h2>
            {course.title}
        </h2>
        {@html course.text}
    {/each}
</div>

<style lang="scss">
    @import "../../styles/vars";

    p {
        font-family: "Ysabeau";
    }

    img {
        width: 40%;
        float: left;
    }

    .courses :global(p) {
        font-family: "Ysabeau";
        font-size: 1.25rem;
        margin: 0;
        display: inline;
    }

    .courses :global(a) {
        border-bottom: 2px solid var(--pageColor);
        color: black;

        &:hover {
            text-decoration: none;
        }
    }
</style>
